// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.form-container {\n  height: 100vh;\n  margin-left: auto;\n}\n.form-card {\n  max-width: 512px;\n  height: 100vh;\n  margin-left: auto;\n  padding: 2.5rem !important;\n}\n@media (max-width: 959px) {\n.hidden-sm-and-down {\n    display: none !important;\n}\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
